var _rect, _defs, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlutter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Flutter",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#e8e9eb",
    rx: "15%"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 37409,
    x2: 38109,
    y1: -20285,
    y2: -19585,
    gradientTransform: "matrix(.06 0 0 -.06 -1982.43 -801.48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a237e",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a237e",
    stopOpacity: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#39cefd",
    d: "M191.45 342.89L249.11 401 407.75 241.12H292.4zM292.4 66.69H407.75L162.61 313.82l-57.7-58.13z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#03569b",
    d: "M249.11,401l43.29,43.59H407.75L306.8,342.89Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M334.67,371.16,306.8,342.89,249.11,401Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#16b9fd",
    d: "M191.45,342.87l57.69-58.18,57.7,58.15L249.14,401Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutter);
export default __webpack_public_path__ + "static/media/flutter.f0ee577433160fa19746210d554c6c0d.svg";
export { ForwardRef as ReactComponent };